module.exports = __webpack_public_path__ + "762e345b51fbff1846aa1dd4aeee75dc.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/foundation.jpg
 ** module id = 476
 ** module chunks = 0
 **/